import { Column } from "@ant-design/charts";
import { Component } from "react";
import "../styles/linechart.css";

class ColumnChart extends Component {
  state = {};

  componentDidMount() {}

  render() {

    const config = {
      data: this.props.data,
      height: 300,
      xField: "days",
      yField: "order",
      label: {
        style: {
          fill: "#aaa"
        }
      }
    };
    return <Column {...config} />;
  }
}

export default ColumnChart;
